import {useEffect, useState} from "react";

import {Button} from "@pg-design/button-module";
import {Container} from "@pg-design/grid-module";
import {flexAbsoluteCenter, mb, mt, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IOfferListOffer} from "../../../offer/types/IOfferListOffer";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {fetchOffersData} from "../actions/fetch_offers_data";
import {MapType} from "../helpers/map_type";
import {PricesViewType} from "../helpers/prices_view_type";
import {maps} from "../utils/district_maps";
import {pricesReportAnalytics, PricesReportGTMViewAction} from "../utils/prices_report_analytics";
import {PricesMapCity} from "./prices_map/PricesMapCity";
import {PricesMapDistricts} from "./prices_map/PricesMapDistricts";

interface IProps {
    type: PricesViewType;
    region: IRegionReportPrice;
}

export const PricesMap = (props: IProps) => {
    const [offers, setOffers] = useState<IOfferListOffer[]>([]);
    const haveDistricts = Object.keys(maps).includes(props.region.slug);
    const mapType = haveDistricts ? MapType.HIGHCHARTS : MapType.OSM;

    useEffect(() => {
        fetchOffersData(props.region.id)
            .then((response) => {
                setOffers(response.results);
            })
            .catch((error) => {
                notifyBugsnagClient(error, "");
            });
    }, []);

    return (
        <Container css={[mb(8), p(0)]}>
            {mapType === MapType.OSM ? <PricesMapCity region={props.region} offers={offers} /> : <PricesMapDistricts region={props.region} type={props.type} />}

            <div css={[flexAbsoluteCenter, mt(3)]}>
                <Button
                    variant="filled_primary"
                    href={rpAppLink.offer.listFriendly({friendlySlug: `nowe-mieszkania-${props.region.slug}`})}
                    onClick={() => pricesReportAnalytics.gtm.viewEvent(PricesReportGTMViewAction.OFFER_BUTTON_CLICK)}
                >
                    <Text variant="button_big">{`nowe mieszkania ${props.region.short_name}`}</Text>
                </Button>
            </div>
        </Container>
    );
};
import {useEffect, useState} from "react";

import {Button} from "@pg-design/button-module";
import {Container} from "@pg-design/grid-module";
import {flexAbsoluteCenter, mb, mt, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IOfferListOffer} from "../../../offer/types/IOfferListOffer";
import {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {fetchOffersData} from "../actions/fetch_offers_data";
import {MapType} from "../helpers/map_type";
import {PricesViewType} from "../helpers/prices_view_type";
import {maps} from "../utils/district_maps";
import {pricesReportAnalytics, PricesReportGTMViewAction} from "../utils/prices_report_analytics";
import {PricesMapCity} from "./prices_map/PricesMapCity";
import {PricesMapDistricts} from "./prices_map/PricesMapDistricts";

interface IProps {
    type: PricesViewType;
    region: IRegionReportPrice;
}

export const PricesMap = (props: IProps) => {
    const [offers, setOffers] = useState<IOfferListOffer[]>([]);
    const haveDistricts = Object.keys(maps).includes(props.region.slug);
    const mapType = haveDistricts ? MapType.HIGHCHARTS : MapType.OSM;

    useEffect(() => {
        fetchOffersData(props.region.id)
            .then((response) => {
                setOffers(response.results);
            })
            .catch((error) => {
                notifyBugsnagClient(error, "");
            });
    }, []);

    return (
        <Container css={[mb(8), p(0)]}>
            {mapType === MapType.OSM ? <PricesMapCity region={props.region} offers={offers} /> : <PricesMapDistricts region={props.region} type={props.type} />}

            <div css={[flexAbsoluteCenter, mt(3)]}>
                <Button
                    variant="filled_primary"
                    href={rpAppLink.offer.listFriendly({friendlySlug: `nowe-mieszkania-${props.region.slug}`})}
                    onClick={() => pricesReportAnalytics.gtm.viewEvent(PricesReportGTMViewAction.OFFER_BUTTON_CLICK)}
                >
                    <Text variant="button_big">{`nowe mieszkania ${props.region.short_name}`}</Text>
                </Button>
            </div>
        </Container>
    );
};
